/* The section header: big title left, mono meta right, a 3px rule under both.
 *
 * This is the only heading furniture on the site. Everything between two of
 * these belongs to the first one, which is why the rule is 3px — it is a
 * container edge, not a data rule, and the scale in tokens.css says so.
 */

import type { ReactNode } from 'react';

export interface SectionProps {
  /** The big word. Kept short: "Today", "Latest", "Archive", "More like this". */
  title: ReactNode;
  /**
   * The mono line on the right. Usually a count and a date, sometimes a link
   * out ("All 214 episodes →"), which is why it takes a node and not a string.
   */
  meta?: ReactNode;
  /**
   * A page gets exactly one h1. Pass 1 on the page's own leading section and
   * leave every other one alone.
   */
  level?: 1 | 2;
  id?: string;
  className?: string;
  /** Anything that has to sit in the header row after the meta, e.g. a control. */
  children?: ReactNode;
}

export function Section({ title, meta, level = 2, id, className, children }: SectionProps) {
  const Heading = level === 1 ? 'h1' : 'h2';

  return (
    <section className={className ? `sec ${className}` : 'sec'} id={id}>
      <Heading>{title}</Heading>
      {meta === undefined || meta === null || meta === false ? null : (
        <div className="mono sec__meta">{meta}</div>
      )}
      {children}
    </section>
  );
}
